







































import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class PageCards extends Vue {
    @Prop() cards: Array<object>;

    goToUrl(path) {
        this.$router.push(path);
    }
}
